import React from 'react';
import ReactDOM from 'react-dom/client'; // Import ReactDOM để render ứng dụng React vào DOM
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './index.css';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import reduxStore from './redux';
import { BrowserRouter } from 'react-router-dom';
const { store, persistor } = reduxStore(); // Khởi tạo Redux Store và Persistor:

const root = ReactDOM.createRoot(document.getElementById('root')); // Sử dụng createRoot của ReactDOM để tạo một "root" renderer trên một phần tử DOM có id là 'root'.
//Sử dụng render để render ứng dụng React vào phần tử DOM 'root'.
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>,
);
/*Sử dụng <Provider> và <PersistGate>:

<Provider store={store} >: Bọc ứng dụng của bạn trong <Provider> để cung cấp Redux Store cho toàn bộ ứng dụng React.
<PersistGate loading={null} persistor={persistor} >: Bọc ứng dụng trong <PersistGate> nó giúp con react delay việc render UI cho tới khi store được updated. Thuộc tính loading đặt thành null có nghĩa là không có giao diện người dùng được hiển thị trong khi Redux Persist đang hoạt động.
<BrowserRouter>: Bọc ứng dụng trong <BrowserRouter> để sử dụng định tuyến trong ứng dụng React. */
